import React from 'react';
import Navbar from './Navbar/Navbar';
import ScrollToTop from './ScrollToTop';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-background-dark font-display">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow" role="main" aria-label="Main content">
        {children}
      </main>
    </div>
  );
};

export default Layout; 